import { useMessageToState } from "./useMessageToState";

const getProductCode = (editor: eXpress.core.IEditor) =>
	editor.definition?.product.code ?? undefined;

/** Returns the current productCode */
export function useProductCode() {
	return useMessageToState({
		name: "useProductCode",
		filterMessage: eXpress.core.isProductCodeChanged,
		getState: getProductCode,
	});
}
